module.exports = __webpack_public_path__ + "img/coupon-popup-bg-hen.df7bfc54.png";